import DuplicateSkusModal from './DuplicateSkusModal';

export default DuplicateSkusModal;
